import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,FormGroup,ControlLabel,FormControl} from "react-bootstrap";
import { API } from "aws-amplify";
import Moment from 'react-moment';
import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import LoaderButton from "../components/LoaderButton";
import ReactMarkdown from 'react-markdown/with-html'

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}



export default class AuthCodes extends Component {
    constructor(props) {
      super(props);
      this.state = {
          myaltioms:[],
          myaltioms_fetching:true,
          markdown:"",
          newUser:false,
          responce:"",
          code:"",
          isLoading:false
      };
    }

    async componentWillMount() {
      if(this.props.match.params.id.length>0){
        await this.checkcode(this.props.match.params.id)
      }

    }
    responceChanged=(e)=>{
      console.log(e.target.value)
      this.setState({responce:e.target.value})


    }
    validateForm(){
    }
    handleSubmit = async event => {

  }



async checkcode(code){


  this.setState({ isLoading: true });

  //send a request to the welcome function with some extra qyery parameters
  const responce=await this.getAccess(code);
  console.log(responce)
  this.setState({ isLoading: false });
  this.setState(responce)
  this.setState({ webresponce:responce.code})
  this.setState({ markdown:responce.markdown})
  this.setState({ newUser:responce.newUser})
  console.log(responce.code)
if(responce.code=="Permissions have been added"){
  this.props.history.push("/a");
}else{
  this.setState({code:responce.code})
}

}

getAccess(note){
  let data = {
    'queryStringParameters': {
        'note': note,
        'newUser': true
    }
  }
  return API.get("AltiomData", "/welcome",data);
}

    render() {
      return (
          <div className="Home">
            <Jumbotron>
            <h2>  Verifying.... </h2>
            <i>AuthCode:{this.props.match.params.id}</i>
            <br/>
            <b>{this.state.code}</b>

            </Jumbotron>
          </div>
        );
    }
}

//{this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}



// WEBPACK FOOTER //
// ./src/containers/AuthCode.js